import { useEffect, useState } from "react";
import { MessageCircle, UserPlus } from "lucide-react";
import { api } from "../../lib/api";
import { SocialIcon } from "../../lib/social";

const Row = ({ label, items, testPrefix, IconName }) => (
  <div data-testid={testPrefix}>
    <p className="mb-3 flex items-center gap-2 font-mono-x text-[11px] uppercase tracking-[0.25em] text-amber-400">
      <IconName className="h-3.5 w-3.5" /> {label}
    </p>
    <div className="flex flex-wrap gap-2.5">
      {items.map((s) => (
        <a key={s.id} href={s.href} target="_blank" rel="noopener noreferrer" data-testid={`${testPrefix}-${s.id}`}
          className="flex items-center gap-2 rounded-full border border-amber-700/50 px-4 py-2.5 text-sm font-semibold text-amber-100 transition-colors duration-300 hover:bg-amber-400 hover:text-stone-950">
          <SocialIcon id={s.icon} /> {s.name}
        </a>
      ))}
    </div>
  </div>
);

export const Follow = () => {
  const [links, setLinks] = useState([]);
  useEffect(() => {
    api.get("/social-links").then((r) => setLinks(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);
  if (!links.length) return null;
  return (
    <div className="mt-10 grid gap-8 rounded-3xl border border-amber-900/40 bg-[#181512] p-7 md:grid-cols-2 md:p-9" data-testid="follow-section">
      <Row label="Suivez-moi" testPrefix="follow" IconName={UserPlus}
        items={links.map((l) => ({ id: l.id, name: l.name, icon: l.icon, href: l.url }))} />
      <Row label="Écrivez-moi en privé" testPrefix="dm" IconName={MessageCircle}
        items={links.filter((l) => l.dm_url).map((l) => ({ id: l.id, name: l.name, icon: l.icon, href: l.dm_url }))} />
    </div>
  );
};
